import { Icon, Modal, Spin } from "antd";
import style from "./index.module.scss";
import React from "react";
import ListItem from "./component/ListItem";
import { ZipPaperListItem } from "service/exam";
import _ from "underscore";
import CustomEmpty from "components/CourseComponents/CustomEmpty";

interface TaskModalProps {
    visible: boolean;
    onCancel: () => void; //关闭弹窗
    dataList: { [key: string]: ZipPaperListItem[] }[]; //打包列表
    loading: boolean; //加载状态
    packageName: string; //包名
    show7days?: boolean;
}

export default function TaskModal({
    visible,
    onCancel,
    dataList,
    loading,
    packageName,
    show7days = false
}: TaskModalProps) {
    const footer = <div className={style.footer}>-仅保留七日内的导入结果-</div>;

    return (
        <Modal
            visible={visible}
            title="任务中心"
            onCancel={onCancel}
            className={style.root}
            width={610}
            maskClosable={false}
            footer={show7days && dataList.length > 0 ? footer : null}>
            <div className={style.header}>
                <Icon type="info-circle" className={style.icon} />
                <div className={style.tips}>
                    关闭"任务中心"窗口、切换页面或退出系统，批量打包任务仍在继续，待任务完成后，您需在当前窗口点击“下载”按钮进行下载
                </div>
            </div>
            <div className={style.container}>
                <Spin spinning={loading}>
                    {dataList.map(item => (
                        <div className={style.items} key={Math.random()}>
                            <div className={style.itemTitle}>
                                {Object.keys(item)}
                            </div>
                            {_.flatten(Object.values(item)).map(item => (
                                <ListItem
                                    data={item}
                                    key={item.uuid}
                                    packageName={packageName}
                                />
                            ))}
                        </div>
                    ))}
                </Spin>
                {dataList.length === 0 && (
                    <CustomEmpty style={{ padding: "76px 0" }} />
                )}
            </div>
        </Modal>
    );
}
